import { IInsertTableRowColManager } from '@src/slide/application/service/insert-table-row-col-manager/index.interface';
import { observable, reaction } from 'mobx';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

interface IInsertTableRowColManagerProps {
    selectionService: ISelectionService;
    menuManager: IMenuManager;
}

export class InsertTableRowColManager implements IInsertTableRowColManager {
    @observable public insertTopRowNumber = 1;
    @observable public insertBottomRowNumber = 1;
    @observable public insertLeftColNumber = 1;
    @observable public insertRightColNumber = 1;
    private selectionService: ISelectionService;
    private menuManager: IMenuManager;

    constructor(props: IInsertTableRowColManagerProps) {
        const { selectionService, menuManager } = props;
        this.selectionService = selectionService;
        this.menuManager = menuManager;
        reaction(() => [
            this.selectionService.getSelectedModel(),
            this.menuManager.isMenuShown,
            (this.selectionService.getSelectedModel() as ITableModel)?.selectedRange,
        ], ([model]) => {
            const tableModel = model as ITableModel;
            if (tableModel?.type === UIModelType.TABLE && !this.menuManager.isMenuShown) {
                const rowCount = tableModel.selectedRange
                    ? tableModel.selectedRange.rowEnd - tableModel.selectedRange.rowStart + 1
                    : 0;
                this.insertTopRowNumber = rowCount;
                this.insertBottomRowNumber = rowCount;
                const colCount = tableModel.selectedRange
                    ? tableModel.selectedRange.colEnd - tableModel.selectedRange.colStart + 1
                    : 0;
                this.insertLeftColNumber = colCount;
                this.insertRightColNumber = colCount;
            }
        });
    }
}
